import { render, staticRenderFns } from "./BuyPoint.vue?vue&type=template&id=6b6a32a0&scoped=true&"
import script from "./BuyPoint.vue?vue&type=script&lang=js&"
export * from "./BuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./BuyPoint.vue?vue&type=style&index=0&id=6b6a32a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a32a0",
  null
  
)

export default component.exports